import { render, staticRenderFns } from "./ProjectsListCard.vue?vue&type=template&id=7a38661d&scoped=true"
import script from "./ProjectsListCard.vue?vue&type=script&lang=ts"
export * from "./ProjectsListCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsListCard.vue?vue&type=style&index=0&id=7a38661d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a38661d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a38661d')) {
      api.createRecord('7a38661d', component.options)
    } else {
      api.reload('7a38661d', component.options)
    }
    module.hot.accept("./ProjectsListCard.vue?vue&type=template&id=7a38661d&scoped=true", function () {
      api.rerender('7a38661d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectsListCard.vue"
export default component.exports